.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 32px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  line-height: 24px;
  font-weight: bold;
  background-color: var(--color-easil-black);
  border: solid 2px white;
  color: white;
  background-position: center;
  background-size: cover;
}

.light {
  background-color: white;
  color: var(--color-easil-black);
  border: solid 1px var(--color-easil-black);
}

.gray {
  background-color: var(--color-easil-gray-x-light);
  color: white;
  border: solid 2px white;
}

.chars {
  font-family: Roboto;
  font-size: 40%;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
